import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import SwiperCore, { EffectCoverflow, Navigation } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./index.scss";

import WxModal from "./WxModal";

interface IProps {}

interface IState {
    showPlayBtn: boolean;
    showWxModal: boolean;
}

const url = "https://static.jjbisai.com/website/videos/hxzyy/pv.mp4";

const PicList = [
    { id: 1, url: "https://static.jjbisai.com/website/imgs/hxzyy/second/pic-1.jpg" },
    { id: 2, url: "https://static.jjbisai.com/website/imgs/hxzyy/second/pic-2.jpg" },
    { id: 3, url: "https://static.jjbisai.com/website/imgs/hxzyy/second/pic-3.jpg" },
    { id: 4, url: "https://static.jjbisai.com/website/imgs/hxzyy/second/pic-4.jpg" },
    { id: 5, url: "https://static.jjbisai.com/website/imgs/hxzyy/second/pic-5.jpg" },
    { id: 6, url: "https://static.jjbisai.com/website/imgs/hxzyy/second/pic-6.jpg" },
];

const { Swiper, SwiperSlide } = require("swiper/swiper-react.cjs.js");

SwiperCore.use([EffectCoverflow, Navigation]);

// 第二屏
class Second extends BaseComponent<IProps, IState> {
    private videoRef: React.RefObject<any>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            showPlayBtn: true,
            showWxModal: false,
        };
        this.videoRef = React.createRef();
    }

    changeBtnStatue = (showPlayBtn: boolean) => {
        this.setState({
            showPlayBtn,
        });
    };

    onPlay = () => {
        this.videoRef.current.play();
        this.changeBtnStatue(false);
    };

    onPause = () => {
        this.videoRef.current.pause();
        this.changeBtnStatue(true);
    };

    onChangeWxModal = (showWxModal: boolean) => {
        this.setState({
            showWxModal,
        });
    };

    render() {
        const { showWxModal, showPlayBtn } = this.state;
        return (
            <div className="second-page">
                <div className="pv-title"></div>
                <div className="pv-video">
                    {showPlayBtn ? <div className="btn-play" onClick={this.onPlay}></div> : <div className="video-mask" onClick={this.onPause}></div>}
                    <video
                        ref={this.videoRef}
                        src={url}
                        poster="https://static.jjbisai.com/website/imgs/hxzyy/second/bg-video.png"
                        preload={"true"}
                        // controls
                        x5-video-player-fullscreen="true"
                        x5-playsinline="true"
                        playsInline
                        webkit-playsinline="true"
                    ></video>
                </div>
                <div className="character-title"></div>
                <div className="carousel">
                    <Swiper
                        className="swiper-container game-swiper"
                        effect="coverflow"
                        slidesPerView="auto"
                        loop={true}
                        centeredSlides={true}
                        coverflowEffect={{ rotate: 0, stretch: 20, depth: 20, modifier: 6, slideShadows: true }}
                        navigation={true}
                        spaceBetween={60}
                    >
                        {PicList.map((item) => {
                            return (
                                <SwiperSlide key={item.id}>
                                    <div className="pic-box" style={{ backgroundImage: `url(${item.url})` }}></div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <div className="bottom-line">
                    <a className="btn qq" href="https://jq.qq.com/?_wv=1027&k=VhldEgJN" title="QQ" target="_blank"></a>
                    <div className="btn wx" onClick={() => this.onChangeWxModal(true)}></div>
                    <a className="btn bili" href="https://www.biligame.com/detail/?id=108087" title="bilibili" target="_blank"></a>
                    <a className="btn tap" href="https://tap.cn/b9TIKFDA?channel=rep-rep_gxfhdbxjaf5" title="taptap" target="_blank"></a>
                    <a className="btn hykb" href="https://www.3839.com/a/139371.htm?from=hykb" title="hykb" target="_blank"></a>
                    <a className="btn jj" href="https://www.jj.cn" title="jj" target="_blank"></a>
                </div>
                {showWxModal ? <WxModal onClose={() => this.onChangeWxModal(false)} /> : null}
            </div>
        );
    }
}

export default Second;
